
import { Component, Vue } from 'vue-property-decorator';
import { NotificationInterface, ProfileRepositoryInterface } from '@/services/Users-profile/interfaces';

@Component({
  inject: [
    'profileRepository',
  ],
})
export default class Notifications extends Vue {
  private noNotificationsText: string = 'No new notifications';
  private profileRepository!: ProfileRepositoryInterface;

  private get notifications(): NotificationInterface[] {
    return this.$store.getters.notifications.unread;
  }

  private get readNotifications(): NotificationInterface[] {
    return this.$store.getters.notifications.read;
  }

  private get popupsEnabled(): boolean {
    return !!this.$store.getters.wsPopupsEnabled;
  }

  private get badgeCount(): string {
    const count = this.notifications.length;
    return count > 99 ? '99+' : String(count);
  }

  private levelColor(level: string): string {
    switch (level) {
      case 'success':
        return 'success';
      case 'error':
        return 'error';
      case 'warning':
        return 'warning';
      default:
        return 'info';
    }
  }

  private async markAllAsRead(): Promise<void> {
    this.$store.commit('MARK_ALL_AS_READ');
    await this.profileRepository.markAllNotificationsAsRead();
  }

  private async markAsRead(notificationId: string): Promise<void> {
    if (!notificationId) {
      return;
    }

    this.$store.commit('MARK_AS_READ', notificationId);
    await this.profileRepository.markNotificationAsRead(notificationId);
  }
}
